import axios from 'axios'
import store from "../../store"

const baseUrl = (process.env.NODE_ENV === 'development') ?
        `http://${window.location.hostname}:8081` :
        `http://${window.location.hostname}:8081`;

var api = axios.create({
    baseURL: baseUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
      const token = localStorage.getItem('token');

      if (token) {
          config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    }, (err) => {
      return Promise.reject(err);
    });

api.interceptors.response.use(response => {
      return response;
    }, error => {
      if (error.response.status === 401 && error.response.data.codigo && error.response.data.codigo === 1) {
        store.dispatch('auth/ActionSignOut');
        window._Vue.$router.push({ path: `/login`, query: {previous: window._Vue.$router.currentRoute.path} });
      }

      return Promise.reject(error);
    });

export default api
